import axios from 'axios'
import { URIS, loadHeaders } from '../Uris'
import { notify } from 'react-notify-toast'

import { restoresConstants, uiConstants } from '../constants'

export function restoresUpload() {
  return {
    type: restoresConstants.RESTORES_UPLOADING
  }
}

export function restoresUploadSuccess() {
  return {
    type: restoresConstants.RESTORES_UPLOADING_SUCCESS
  }
}

export function loadRestores(payload) {
  return (dispatch) => {
    dispatch(loadingRestores(payload))
    axios({
      method: 'GET',
      url: URIS.restores + '?id=' + payload,
      headers: loadHeaders()
    })
      .then((res) => {
        dispatch(loadRestoresSuccess(res.data))
      })
      .catch((error) => {
        if (error.response !== undefined) {
          dispatch(loadRestoresFailure(error.response.statusText))
        } else {
          dispatch(loadRestoresFailure(error.message))
        }
        notify.show(
          'Errore caricamento anomalie',
          uiConstants.toast.error,
          3000
        )
      })
  }
}

function loadingRestores(payload) {
  return {
    type: restoresConstants.LOADING_RESTORES,
    payload
  }
}

function loadRestoresSuccess(payload) {
  return {
    type: restoresConstants.LOADING_RESTORES_SUCCESS,
    payload
  }
}

function loadRestoresFailure(payload) {
  return {
    type: restoresConstants.LOADING_RESTORES_FAILURE,
    payload
  }
}

export function saveInterventions(payload) {
  return (dispatch) => {
    dispatch(changeInterventionsRestores(payload))
    axios({
      method: 'PUT',
      url: URIS.restores,
      data: payload,
      headers: loadHeaders()
    })
      .then((res) => {
        dispatch(changeInterventionsRestoresSuccess(res.data))
        notify.show(
          'Numero interventi salvato',
          uiConstants.toast.success,
          3000
        )
      })
      .catch((error) => {
        if (error.response !== undefined) {
          dispatch(
            changeInterventionsRestoresFailure(error.response.statusText)
          )
        } else {
          dispatch(changeInterventionsRestoresFailure(error.message))
        }
        notify.show(
          'Errore salvataggio numero interventi',
          uiConstants.toast.error,
          3000
        )
      })
  }
}

function changeInterventionsRestores() {
  return {
    type: restoresConstants.UPDATE_INTERVENTIONS
  }
}

function changeInterventionsRestoresSuccess(payload) {
  return {
    type: restoresConstants.UPDATE_INTERVENTIONS_SUCCESS,
    payload
  }
}

function changeInterventionsRestoresFailure(payload) {
  return {
    type: restoresConstants.UPDATE_INTERVENTIONS_FAILURE,
    payload
  }
}
